import { FlexCenter } from "styles/GlobalStyle"
import AudioPlayerCell from "../AudioPlayerCell"


const usePlayCell = () => {
    const playField = {
        accessorKey: 'audio_file_url',
        header: "נגן",
        meta: {
            width: "163px",
            height: "35px",
        },
        showBlurred: true,
        cell: AudioPlayerCell,
        enableSorting: false
    }

    return playField
}

export default usePlayCell